export const getEnvVar = (varName: string, defaultValue = "") =>
  process.env?.[`REACT_APP_${varName}`] ?? defaultValue;
